<label class="form-control__label">
  <p class="t-data t-bold">{{ config.label }}</p>
</label>

<div class="basic-address__row">
  @for (control of addressLine1; track control) {
    <form-control
      class="basic-address__control"
      [control]="group.controls[config.prop].controls[control.prop]"
      [config]="control"
      direction="grouping"
    >
    </form-control>
  }
</div>

<div class="basic-address__row basic-address__row--2">
  @for (control of addressLine2; track control) {
    <form-control
      class="basic-address__control"
      [control]="group.controls[config.prop].controls[control.prop]"
      [config]="control"
      direction="grouping"
    >
    </form-control>
  }
</div>
